module.exports = __webpack_public_path__ + "static/media/bear_phone_border.d1aad0bc.png";